import type { EndpointsRegistry, FetchClient } from '~/api/types'
import { GatewayEndpoints } from '~/api/endpoints/gateway-endpoints'
import type { FiltersService } from '~/api/services/types'
import type { SuccessNoContent } from '~/types/common'
import type { AssetFilters } from '~/types/filters'

export const registerEndpoints = (client: FetchClient, registry: EndpointsRegistry): FiltersService => {
  return {
    getAllFilters: async () => {
      const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.FILTERS_GET_ALL, {
        queryParams: { include_shared: true }
      })
      return await client<AssetFilters[]>(url, { method, headers, body })
    },
    getFilterById: async (id: number) => {
      const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.FILTERS_GET_BY_ID, {
        params: { id }
      })
      return await client<AssetFilters>(url, { method, headers, body })
    },
    createFilter: async (filterData: Partial<AssetFilters>) => {
      const { page, pageSize, ...bodyFilters } = filterData
      const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.FILTERS_CREATE, {}, bodyFilters)
      return await client<AssetFilters>(url, { method, headers, body })
    },
    updateFilter: async (id: number, filterData: Partial<AssetFilters>) => {
      const { page, pageSize, ...bodyFilters } = filterData
      const { url, method, headers, body } = registry.createRequest(
        GatewayEndpoints.FILTERS_UPDATE,
        { params: { id } },
        bodyFilters
      )
      return await client<AssetFilters>(url, { method, headers, body })
    },
    deleteFilter: async (id: number) => {
      const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.FILTERS_DELETE, { params: { id } })
      return await client<SuccessNoContent>(url, { method, headers, body })
    }
  }
}
